import React, { useEffect, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import AlertsApi from "../Apis/AlertsApi.js";
import UserApi from "../Apis/UserApi.js";
import { Badge, Spin } from "antd";
import { Popover, List, notification, Button } from "antd";
import {
  BellOutlined,
  InfoCircleOutlined,
  WarningOutlined,
  AlertOutlined,
  CheckCircleOutlined,
  CloseOutlined,
  LeftSquareOutlined,
  RightSquareOutlined,
  LeftSquareTwoTone,
  RightSquareTwoTone,
} from "@ant-design/icons";

const Notifications = () => {
  let navigate = useNavigate();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [Alerts, setAlerts] = React.useState([]);
  const [TotalNotification, setTotalNotification] = useState(null);
  const [visible, setVisible] = useState(false);

  const [AlertPagination, setAlertPagination] = useState(4);
  const [currentPage, setCurrentPage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [loading, setLoading] = useState(false);

  const handlePageChange = (nav) => {
    setLoading(true);
    setTimeout(() => {
        const totpages = PaginatetotalPages - 1;
        let newCurrentPage = currentPage;
      
        if (nav === 0 && currentPage > 0) {
          newCurrentPage = currentPage - 1; 
        } else if (nav === 1 && currentPage <= totpages) {
          newCurrentPage = currentPage + 1; 
        }
      
        setCurrentPage(newCurrentPage);
    
        AlertsApi.ListAlerts(AlertPagination, newCurrentPage)
          .then((response) => {
            setAlerts(response?.payloadDto?.filter((item) => item?.read === false));
            settotalPages(response?.totalPages);
            setCurrentPage(response?.number);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
          });
    }, 100);
  };
  
  const renderPagination = () => {
    let buttonStyle = {
      outline: "none",
      border: "none",
      padding: "0 10px",
      textAlign: "center",
      backgroundColor: "transparent",
    };

    const totpages = PaginatetotalPages - 1;

    return (
      <>
        {currentPage === 0 ? (
          <>
            {" "}
            <Button
              onClick={() => handlePageChange(0)}
              style={buttonStyle}
              icon={<LeftSquareOutlined />}
              disabled={true}
            />
            <Button
              onClick={() => handlePageChange(1)}
              style={buttonStyle}
              icon={<RightSquareTwoTone />}
            />{" "}
          </>
        ) : currentPage === totpages ? (
          <>
            {" "}
            <Button
              onClick={() => handlePageChange(0)}
              style={buttonStyle}
              icon={<LeftSquareTwoTone />}
            />
            <Button
              onClick={() => handlePageChange(1)}
              style={buttonStyle}
              disabled={true}
              icon={<RightSquareOutlined />}
            />{" "}
          </>
        ) : (
          <>
            <Button
              onClick={() => handlePageChange(0)}
              style={buttonStyle}
              icon={<LeftSquareTwoTone />}
            />
            <Button
              onClick={() => handlePageChange(1)}
              style={buttonStyle}
              icon={<RightSquareTwoTone />}
            />
          </>
        )}
      </>
    );
  };

  const getAlerts = useCallback(() => {
    AlertsApi.ListAlerts(AlertPagination, currentPage)
      .then((response) => {
        setAlerts(response?.payloadDto?.filter((item) => item?.read === false));
        settotalPages(response?.totalPages);
        setCurrentPage(response?.number);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getNotification = useCallback(() => {
    UserApi.UserNotification()
      .then((response) => {
        setTotalNotification(response?.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getAlerts();
    getNotification();
  }, [getAlerts, getNotification]);

const handleClickNotification = (Alert) => {
  if (Alert?.stockDTO?.invoiceNumber) {
    const invoiceId = encodeURIComponent(Alert.stockDTO.invoiceNumber);
    const batchCode = encodeURIComponent(Alert.stockDTO.batchCode);

    navigate(
      `/stock?invoice_id=${invoiceId}&batch=${batchCode}`
    );
  }
};

  const handleSubmitAlert = (Alert) => {
    AlertsApi.DeleteAlerts(Alert?.id)
      .then((response) => {
        getAlerts();
        getNotification();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleVisibleChange = (isVisible) => {
    setVisible(isVisible);
    if(!isVisible){
        setCurrentPage(0);
        getAlerts();
        setLoading(false);
    }
    
   
  };


  const NotificationList = ({ notifications, onClose }) => (
    <Spin 
    spinning={loading}
    size={"small"}
    >
    <List
      dataSource={notifications}
      renderItem={(item, index) => (
        <List.Item key={index}>
          <div className={item.severity}>
            <div className="AlertNotification" style={{borderRadius:5}}>
              <div style={{ width: "10%" }}>
                {item.severity === "LOW" && (
                  <>
                    {" "}
                    <CheckCircleOutlined />
                  </>
                )}
                {item.severity === "MODERATE" && (
                  <>
                    {" "}
                    <InfoCircleOutlined />
                  </>
                )}
                {item.severity === "HIGH" && (
                  <>
                    {" "}
                    <AlertOutlined />
                  </>
                )}
                {item.severity === "CRITICAL" && (
                  <>
                    {" "}
                    <WarningOutlined />
                  </>
                )}
                {item.severity === "INFORMATIONAL" && (
                  <>
                    {" "}
                    <InfoCircleOutlined />
                  </>
                )}
                {item.severity === "WARNING" && (
                  <>
                    {" "}
                    <WarningOutlined />
                  </>
                )}
              </div>
              <div style={{ width: "80%", display: "block" }}>
                <p
                  className="AlertHeader m-0 p-0"
                  onClick={() => handleClickNotification(item)}
                >
                  {item.alertType}
                </p>
                <p
                  className="AlertContent m-0 p-0"
                  onClick={() => handleClickNotification(item)}
                >
                  {item.description}
                </p>
              </div>
              <div style={{ width: "10%" }}>
                <Button
                  type="text"
                  onClick={() => handleSubmitAlert(item)}
                  icon={<CloseOutlined />}
                />
              </div>
            </div>
          </div>
        </List.Item>
      )}
      footer={TotalNotification > 4 && renderPagination()}
    />
    </Spin>
  );

  return (
    <>
      <Popover
        content={<NotificationList notifications={Alerts} />}
        title="Notifications"
        trigger="click"
        style={{ width: 600 }}
        visible={visible}
        onOpenChange={handleVisibleChange}
      >
        <Badge count={TotalNotification}>
          <BellOutlined
            style={{
              fontSize: "20px",
              marginRight: "5px",
              cursor: "pointer",
            }}
          />
        </Badge>
      </Popover>
    </>
  );
};

export default Notifications;
